(() => {
  'use strict';
  const match = (products, models, answer) => {
    const specs = new Map(models.map(m => [String(m.id), m]));
    const results = [];
    for (const product of products) {
      const model = specs.get(String(product.id));
      if (!model || (answer.firmness !== 'any' && model.firmness !== answer.firmness) || (answer.type !== 'any' && model.type !== answer.type)) continue;
      const sizeIndex = product.options.findIndex(o => String(o).toLowerCase() === 'size');
      if (sizeIndex < 0) continue;
      const eligible = product.variants.filter(v => v.available === true && String(v.options[sizeIndex]).toLowerCase() === answer.size.toLowerCase() && Number.isFinite(v.price) && v.price <= answer.budget).sort((a, b) => a.price - b.price || String(a.id).localeCompare(String(b.id)));
      if (eligible.length) results.push({product, model, variant: eligible[0]});
    }
    return results.sort((a,b) => a.variant.price - b.variant.price || a.model.name.localeCompare(b.model.name));
  };
  globalThis.UltraFlexFinderMatch = match;
  if (!globalThis.customElements || customElements.get('ultraflex-finder')) return;
  class UltraFlexFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.stage = 0;
      try {
        this.config = JSON.parse(this.querySelector('[data-finder-config]').textContent);
        this.catalogue = JSON.parse(this.querySelector('[data-finder-products]').textContent);
        this.msg = this.config.messages;
        this.config.models = (this.catalogue.products || []).map(product => product.finder).filter(Boolean);
        if (!this.catalogue.complete || !Array.isArray(this.catalogue.products) || !this.catalogue.products.length) throw new Error('Catalogue incomplete');
        this.money = new Intl.NumberFormat('en-CA', {style:'currency', currency:this.catalogue.currency || 'CAD'});
        this.form = this.querySelector('form');
        this.fields = [...this.querySelectorAll('[data-stage]')];
        this.error = this.querySelector('[data-error]');
        this.results = this.querySelector('[data-results]');
        this.cards = this.querySelector('[data-cards]');
        this.querySelector('[data-currency-label]').textContent = '('+(this.catalogue.currency || 'CAD')+')';
        this.form.addEventListener('submit', e => {e.preventDefault(); if (!this.validate()) return; if (this.stage < 3) {this.stage++;this.showStage();} else this.find();});
        this.querySelector('[data-back]').addEventListener('click', () => {this.stage=Math.max(0,this.stage-1);this.showStage();});
        this.form.elements.unlimited.addEventListener('change', () => {this.form.elements.budget.disabled=this.form.elements.unlimited.checked;this.error.textContent='';});
        this.form.addEventListener('input', () => {this.error.textContent='';});
        this.querySelector('[data-edit]').addEventListener('click', () => {this.stage=0;this.results.hidden=true;this.querySelector('.uff-shell').hidden=false;this.showStage();});
        this.querySelector('[data-reset]').addEventListener('click', () => {this.form.reset();try{sessionStorage.removeItem('ultraflex-mattress-choices');}catch(e){}this.form.elements.budget.disabled=false;this.stage=0;this.results.hidden=true;this.cards.replaceChildren();this.querySelector('.uff-shell').hidden=false;this.showStage();});
        this.querySelector('[data-more]').addEventListener('click', () => {const previous=this.visible;this.visible+=12;this.renderCards();const card=this.cards.children[previous];if(card){card.setAttribute('tabindex','-1');card.focus();}});
        this.showStage(false);
        this.restoreAnswers();
      } catch (e) {
        const err = this.querySelector('[data-error]');
        err.textContent = this.config?.messages?.load_error || 'The finder could not load. Please refresh the page or contact us.';
        this.querySelector('[data-next]').disabled=true;
      }
    }
    restoreAnswers() {
      try {
        const saved=JSON.parse(sessionStorage.getItem('ultraflex-mattress-choices')||'null');
        if(!saved || saved.version!==1)return;
        for(const key of ['size','firmness','type']) {
          const option=[...this.form.querySelectorAll('input[name="'+key+'"]')].find(input=>input.value===saved[key]);
          if(!option)return;
          option.checked=true;
        }
        this.form.elements.unlimited.checked=saved.unlimited===true;
        this.form.elements.budget.value=String(saved.budget||'');
        this.form.elements.budget.disabled=this.form.elements.unlimited.checked;
        if(!this.form.elements.unlimited.checked && !(Number(saved.budget)>0))return;
        this.find(false);
      } catch(e) {}
    }
    showStage(focus=true) {
      this.fields.forEach((field,i) => {field.hidden=i!==this.stage;});
      this.querySelector('[data-step]').textContent=String(this.stage+1);
      this.querySelector('[data-progress]').style.width=((this.stage+1)*25)+'%';
      this.querySelector('[data-back]').hidden=this.stage===0;
      this.querySelector('[data-next]').textContent=this.stage===3?this.msg.find:this.msg.next;
      this.error.textContent='';
      if(focus)this.fields[this.stage].querySelector('legend').focus();
    }
    validate() {
      const data=new FormData(this.form);
      const budget=Number(data.get('budget'));
      const invalid=[!data.get('size'),!data.has('unlimited')&&(!Number.isFinite(budget)||budget<=0),!data.get('firmness'),!data.get('type')];
      if(invalid[this.stage]){this.error.textContent=this.msg[['error_size','error_budget','error_firmness','error_type'][this.stage]];return false;}
      return true;
    }
    find(focus=true) {
      const data=new FormData(this.form);
      this.answer={size:data.get('size'),budget:data.has('unlimited')?Infinity:Math.round(Number(data.get('budget'))*100),firmness:data.get('firmness'),type:data.get('type')};
      if(!this.answer.size||!this.answer.firmness||!this.answer.type||this.answer.budget<=0){this.stage=0;this.showStage();return;}
      try{sessionStorage.setItem('ultraflex-mattress-choices',JSON.stringify({version:1,size:this.answer.size,budget:data.get('budget'),unlimited:data.has('unlimited'),firmness:this.answer.firmness,type:this.answer.type}));}catch(e){}
      this.matchResults=match(this.catalogue.products,this.config.models,this.answer);
      this.visible=this.matchResults.length;
      this.querySelector('.uff-shell').hidden=true;
      this.results.hidden=false;
      const a=this.answer;
      this.querySelector('[data-summary]').textContent=[a.size,a.budget===Infinity?this.msg.no_limit:this.msg.up_to+' '+this.money.format(a.budget/100),a.firmness==='any'?this.msg.firmness_label+': '+this.msg.any:a.firmness,a.type==='any'?this.msg.type_label+': '+this.msg.any:a.type].join(' · ');
      this.querySelector('#uff-results-heading').textContent=this.matchResults.length?this.msg.results_title:this.msg.no_matches;
      this.querySelector('[data-result-note]').textContent=this.matchResults.length?this.msg.results_intro:this.msg.no_matches_text;
      this.querySelector('[data-count]').textContent=this.matchResults.length+' '+this.msg.match_count;
      this.querySelector('[data-tax]').hidden=!this.matchResults.length;
      this.renderCards();
      if(focus)this.querySelector('#uff-results-heading').focus();
    }
    renderCards() {
      this.cards.replaceChildren();
      const text=(tag,value,cls)=>{const node=document.createElement(tag);node.textContent=value;if(cls)node.className=cls;return node;};
      for(const {product,model,variant} of this.matchResults.slice(0,this.visible)) {
        const card=document.createElement('article');card.className='uff-card';
        const url=new URL(product.url,location.protocol === 'file:' ? 'https://ultraflexmattress.ca' : location.origin);url.searchParams.set('variant',String(variant.id));
        const imageLink=document.createElement('a');imageLink.href=url.href;imageLink.setAttribute('aria-label',model.name);
        if(product.image){const image=document.createElement('img');image.src=product.image;image.alt=product.alt||model.name;image.loading='lazy';image.width=700;image.height=560;imageLink.append(image);}
        card.append(imageLink);
        const body=document.createElement('div');body.className='uff-card-body';
        const heading=document.createElement('h3');
        model.name.split('®').forEach((part,index)=>{if(index)heading.append(text('sup','®','uff-trademark'));heading.append(document.createTextNode(part));});
        body.append(heading);
        body.append(text('p',model.type+' · '+model.firmness,'uff-spec'));
        body.append(text('p',this.msg.price_from+' '+this.money.format(variant.price/100),'uff-price'));
        body.append(text('p',variant.title,'uff-variant'));
        const link=text('a',this.msg.view,'uff-primary');link.href=url.href;body.append(link);card.append(body);this.cards.append(card);
      }
      this.querySelector('[data-more]').hidden=this.visible>=this.matchResults.length;
    }
  }
  customElements.define('ultraflex-finder',UltraFlexFinder);
})();


